/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Peer_Support_NameInputs */

const en_service_peer_support_name = /** @type {(inputs: Service_Peer_Support_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peer Support Community`)
};

const fr_service_peer_support_name = /** @type {(inputs: Service_Peer_Support_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Communauté de soutien par les pairs`)
};

/**
* | output |
* | --- |
* | "Peer Support Community" |
*
* @param {Service_Peer_Support_NameInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_peer_support_name = /** @type {((inputs?: Service_Peer_Support_NameInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Peer_Support_NameInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_peer_support_name(inputs)
	return fr_service_peer_support_name(inputs)
});